import { setTitle } from "@store/title-store";
import { ErrorIndicator, Loader } from "@ui/indicators";
import NewsItems from "@components/news-components";

import { useProjectNewsQuery } from "@lib/project-news";
import { useLocation } from "react-router-dom";
import { useEffect, FC } from "react";

export const ProjectNews: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = [
      { title: "Главная", href: "/" },
      { title: "Новости", href: "/news/help" },
      { title: "Новости проекта", href: pathname },
    ];

    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data, isLoading, error, hasNextPage, fetchNextPage } =
    useProjectNewsQuery(16);

  return (
    <>
      {error ? (
        <ErrorIndicator />
      ) : isLoading ? (
        <Loader />
      ) : (
        data?.pages.map((page) => (
          <NewsItems items={page.result.rows} path="project" />
        ))
      )}
      {hasNextPage && (
        <button className="pagination-button" onClick={() => fetchNextPage()}>
          Показать еще
        </button>
      )}
    </>
  );
};
